import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useGetCaseTypeById } from 'core/types'

import ModelLink from './ModelLink'

type CaseTypeLinkProps = {
  caseTypeId: string
}

const CaseTypeLink: FC<CaseTypeLinkProps> = ({ caseTypeId }) => {
  const [_, { companyId }] = useQueryApi()
  const { data: caseType, isLoading } = useGetCaseTypeById({
    caseTypeId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  const link = companyId && `/companies/${companyId}/case-types/${caseTypeId}`

  return (
    <ModelLink
      id={caseTypeId}
      isLoading={isLoading}
      link={link}
      model={caseType}
    />
  )
}

export default CaseTypeLink
